module.exports = __webpack_public_path__ + "static/media/expectations.6fc03c9e.png";